<template lang="pug">
div.spinner(v-loading="true")
</template>

<script>
import AuthService from '@/services/AuthService';

export default {
  created() {
    AuthService.handleAuthentication();
  },
};
</script>

<style lang="stylus">
.spinner
  position absolute
  display flex
  justify-content center
  height 100vh
  width 100vw
  background-color white
  top 0
  bottom 0
  left 0
  right 0
</style>



// WEBPACK FOOTER //
// src/components/LoginCallback.vue